import { HttpInterceptorFn } from '@angular/common/http';

/** Orígenes donde no deben enviarse cookies (CORS rechaza Allow-Credentials para Google APIs). */
const SKIP_CREDENTIALS_PREFIXES = ['https://www.googleapis.com'];

export const credentialsInterceptor: HttpInterceptorFn = (req, next) => {
  if (SKIP_CREDENTIALS_PREFIXES.some((prefix) => req.url.startsWith(prefix))) {
    return next(req);
  }
  return next(req.clone({ withCredentials: true }));
};
